import { motion } from 'framer-motion';
import styled from 'styled-components';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { BREAKPOINTS } from '../BeFi20.meta';

export const Wrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  width: '100%',
  alignSelf: 'flex-start',
  background: theme.colors.bg,

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    background: theme.background,
    padding: '0 32px',
  },
}));

export const Content = styled(motion.div)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: 950,
  gap: 32,
  marginTop: 32,

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    margin: '56px auto',
  },
});

export const Main = styled(Box)(({ theme }) => ({
  background: theme.colors.bg,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: 16,
  gap: 24,

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    borderRadius: theme.radii.xxl,
    boxShadow: theme.shadows['500'],
    padding: '56px 64px',
  },
}));
